// MOMKIS - Fiche produit : affichage de la barre sticky mobile.
// Visible uniquement quand le vrai bouton "Ajouter au panier" de la buybox
// est hors du viewport, et masquée dès que le footer apparaît pour ne
// jamais recouvrir son contenu.
(function () {
  var sticky = document.querySelector('[data-momkis-sticky]');
  if (!sticky) return;

  var mainSubmitId = sticky.getAttribute('data-main-submit-id');
  var mainButton = mainSubmitId ? document.getElementById(mainSubmitId) : null;
  var footer = document.querySelector('.momkis-footer, footer');
  if (!mainButton) return;

  var mainButtonVisible = true;
  var footerVisible = false;

  function refresh() {
    var shouldShow = !mainButtonVisible && !footerVisible;
    sticky.classList.toggle('is-visible', shouldShow);
  }

  new IntersectionObserver(
    function (entries) {
      mainButtonVisible = entries[0].isIntersecting;
      refresh();
    },
    { threshold: 0 }
  ).observe(mainButton);

  if (footer) {
    new IntersectionObserver(
      function (entries) {
        footerVisible = entries[0].isIntersecting;
        refresh();
      },
      { threshold: 0, rootMargin: '0px 0px -10% 0px' }
    ).observe(footer);
  }
})();
